import { render, staticRenderFns } from "./ConfigurationAllergies.vue?vue&type=template&id=63781a81&"
import script from "./ConfigurationAllergies.vue?vue&type=script&lang=js&"
export * from "./ConfigurationAllergies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports